import type { PrintProfileFieldLayout } from "shared"

export type { PrintProfileFieldLayout } from "shared"

/**
 * Ukrainian on-screen label for each printed field, keyed by
 * `PrintProfileFieldLayout.id`. Hardcoded on the UI side — the persisted
 * profile (`shared`'s `PrintProfileFieldLayout`) no longer carries a label.
 */
export const protocolV2FieldLabels: Record<string, string> = {
  documentNumber: "№ протоколу",
  protocolDate: "Дата складання протоколу",
  nextInspectionDate: "Дата наступного проходження",
  inspectionPlace: "Місце проведення технічного контролю",
  inspectionEntity: "Суб'єкт проведення технічного контролю",
  vinOrChassisNumber: "VIN або номер кузова (рами)",
  vehicleCategoryMakeModel: "Категорія, марка, модель",
  registrationPlate: "Номерний знак",
  odometer: "Показник одометра",
  stateRegistrationDate: "Дата державної реєстрації",
  ecologicalLevel: "Екологічний рівень",
  cargoCapacity: "Вантажність, тонн",
  vehiclePurpose: "Призначення (додаткова перевірка)",
  punktManager: "Керівник пункту технічного контролю",
}

/** Representative values from the document editor's current mock data. */
export const protocolV2FieldExamples: Record<string, string> = {
  documentNumber: "12345-000124-26",
  protocolDate: "21.07.2026",
  nextInspectionDate: "21.07.2028",
  inspectionPlace: "м. Київ, вул. Прикладна, 1",
  inspectionEntity: "ТОВ «Діагностика Плюс» (ЄДРПОУ: 41234567)",
  vinOrChassisNumber: "WV1ZZZ2EZG6000001",
  vehicleCategoryMakeModel: "N1, Volkswagen Crafter",
  registrationPlate: "АА1234КХ",
  odometer: "184 320",
  stateRegistrationDate: "15.06.2016",
  ecologicalLevel: "Євро-5",
  cargoCapacity: "3,5",
  vehiclePurpose: "Перевезення вантажів",
  punktManager: "Іваненко Іван Іванович",
}

/** Fields printed by the application on the front side of protocol blank v2. */
export const protocolV2PrintedFields: PrintProfileFieldLayout[] = [
  { id: "documentNumber", x: 0.397, y: 0.198, width: 0.237, height: 0.035 },
  { id: "protocolDate", x: 0.307, y: 0.218, width: 0.15, height: 0.04 },
  {
    id: "nextInspectionDate",
    x: 0.498,
    y: 0.281,
    width: 0.4,
    height: 0.04,
  },
  {
    id: "inspectionPlace",
    x: 0.061,
    y: 0.32,
    width: 0.414,
    height: 0.04,
  },
  {
    id: "inspectionEntity",
    x: 0.5,
    y: 0.362,
    width: 0.44,
    height: 0.04,
  },
  {
    id: "vinOrChassisNumber",
    x: 0.332,
    y: 0.407,
    width: 0.371,
    height: 0.04,
  },
  {
    id: "vehicleCategoryMakeModel",
    x: 0.299,
    y: 0.438,
    width: 0.377,
    height: 0.04,
  },
  {
    id: "registrationPlate",
    x: 0.21,
    y: 0.48,
    width: 0.166,
    height: 0.035,
  },
  {
    id: "odometer",
    x: 0.682,
    y: 0.48,
    width: 0.145,
    height: 0.035,
  },
  {
    id: "stateRegistrationDate",
    x: 0.307,
    y: 0.533,
    width: 0.155,
    height: 0.04,
  },
  {
    id: "ecologicalLevel",
    x: 0.649,
    y: 0.553,
    width: 0.296,
    height: 0.04,
  },
  {
    id: "cargoCapacity",
    x: 0.311,
    y: 0.607,
    width: 0.125,
    height: 0.04,
  },
  {
    id: "vehiclePurpose",
    x: 0.508,
    y: 0.654,
    width: 0.42,
    height: 0.04,
  },
  {
    id: "punktManager",
    x: 0.501,
    y: 0.837,
    width: 0.4,
    height: 0.04,
  },
]

export const defaultCalibrationFields: PrintProfileFieldLayout[] = [
  ...protocolV2PrintedFields,
]
